import React from "react";
import styled from "styled-components";
import onClickOutside from "react-onclickoutside";

import {
	opacify,
} from "polished";

const ModalContainer = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: ${ ({ theme, }) => opacify( 0.1, theme.lightGrey ) };
`;

const Modal = (props) => (
	<ModalContainer>
		{ props.children }
	</ModalContainer>
);

export default Modal;
